import React, { Component } from 'react';
import PT from 'prop-types';

export class ReactFormGroupWrapper extends Component {
    render() {

        const ReactFormGroupWrapperView = this.props.viewProvider.getFormGroupWrapperView();
        
        return (
            <ReactFormGroupWrapperView  {...this.props}/>
        );
    }
}

ReactFormGroupWrapper.propTypes = {
    label: PT.oneOfType([PT.string, PT.shape({ fr: PT.string, en: PT.string })]),
    isVisibled: PT.bool,
    helpText: PT.string,
    validationErrors: PT.array,
    validator: PT.func,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    isMultilingual: PT.bool,
    lang: PT.string
};

ReactFormGroupWrapper.defaultProps = {
    helpText: ""
};
